import mandatoryNifByCountryBuilder from './mandatoryNifByCountry/mandatoryNifByCountry';
import fetchCountriesBuilder from './fetchCountries/fetchCountries';
import Translator from '../../infrastructure/Translator';

export default {
  mandatoryNifByCountry: mandatoryNifByCountryBuilder(),
  fetchCountries: fetchCountriesBuilder(new Translator()),
};
